export const Sort = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fill="#55565C"
        fillRule="evenodd"
        d="M6.576 7.242a.6.6 0 1 0 .848.849L10 5.515l2.576 2.576a.6.6 0 1 0 .848-.849l-3-3a.6.6 0 0 0-.848 0l-3 3Zm6.848 5.516a.6.6 0 0 0-.848-.849L10 14.485l-2.576-2.576a.6.6 0 1 0-.848.849l3 3a.6.6 0 0 0 .848 0l3-3Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
